import styled from "styled-components";

export const StatusBarWrapper = styled.div`
    display: flex;
    align-items: center;
    text-align: center ;
    justify-content: space-between; 
    height: 100%;
    background-color: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    flex-direction: row;
    padding: 0 20px;
`;

export const PageTitle = styled.div`
    font-size: 16px;
    font-weight: 600;
    color: #333;
    padding-top: 5px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
`;

export const GoBackWrapper = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    padding-top: 5px;

`

export const GoBackText = styled.span`
    margin-left: 10px;
`